var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 2.25C7.22306 2.25 6.75 2.72306 6.75 3.375V3.9375H3.375V5.0625H3.9375V14.0625C3.9375 14.9929 4.69462 15.75 5.625 15.75H11.1215L12.2465 14.625H5.625C5.31506 14.625 5.0625 14.373 5.0625 14.0625V5.0625H12.9375V10.5029L14.0625 11.6279V5.0625H14.625V3.9375H11.25V3.375C11.25 2.72306 10.7769 2.25 10.125 2.25H7.875ZM7.875 3.375H10.125V3.9375H7.875V3.375ZM6.1875 6.75V12.9375H7.3125V6.75H6.1875ZM8.4375 6.75V12.9375H9.5625V6.75H8.4375ZM10.6875 6.75V10.9534L11.8125 9.82837V6.75H10.6875ZM12.0377 11.194L11.25 11.9817L13.8658 14.5964L11.25 17.2123L12.0377 18L14.6536 15.3842L17.2123 17.944L18 17.1562L15.4402 14.5964L18 12.0377L17.2123 11.25L14.6536 13.8098L12.0377 11.194Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c5e6ef3dac0256e25061d7dd352b1bcb.svg";
export { ForwardRef as ReactComponent };